export const validMeteringTypes = [
  'SLP',
  'RLM',
  'AGG',
  'missing',
  'PK',
  'PW',
  'PG',
  'PK08',
  'PW08',
  'PG08',
  'HE0801',
  'HM0801',
  'HG0801',
  'HE08D-01',
  'HM08D-01',
  'HG08D-01',
  'HE08D+01',
  'HM08D+01',
  'HG08D+01',
  'HE0802',
  'HM0802',
  'HG0802',
  'HE08D-02',
  'HM08D-02',
  'HG08D-02',
  'HE08D+02',
  'HM08D+02',
  'HG08D+02',
  'HE0803',
  'HM0803',
  'HG0803',
  'HE08D-03',
  'HM08D-03',
  'HG08D-03',
  'HE08D+03',
  'HM08D+03',
  'HG08D+03',
  'HE0804',
  'HM0804',
  'HG0804',
  'HE08D-04',
  'HM08D-04',
  'HG08D-04',
  'HE08D+04',
  'HM08D+04',
  'HG08D+04',
  'HE0805',
  'HM0805',
  'HG0805',
  'HE08D-05',
  'HM08D-05',
  'HG08D-05',
  'HE08D+05',
  'HM08D+05',
  'HG08D+05',
  'HE0806',
  'HM0806',
  'HG0806',
  'HE08D-06',
  'HM08D-06',
  'HG08D-06',
  'HE08D+06',
  'HM08D+06',
  'HG08D+06',
  'HE0807',
  'HM0807',
  'HG0807',
  'HE08D-07',
  'HM08D-07',
  'HG08D-07',
  'HE08D+07',
  'HM08D+07',
  'HG08D+07',
  'HE0808',
  'HM0808',
  'HG0808',
  'HE08D-08',
  'HM08D-08',
  'HG08D-08',
  'HE08D+08',
  'HM08D+08',
  'HG08D+08',
  'HE0809',
  'HM0809',
  'HG0809',
  'HE08D-09',
  'HM08D-09',
  'HG08D-09',
  'HE08D+09',
  'HM08D+09',
  'HG08D+09',
  'HE0810',
  'HM0810',
  'HG0810',
  'HE08D-10',
  'HM08D-10',
  'HG08D-10',
  'HE08D+10',
  'HM08D+10',
  'HG08D+10',
  'HE0811',
  'HM0811',
  'HG0811',
  'HE08D-11',
  'HM08D-11',
  'HG08D-11',
  'HE08D+11',
  'HM08D+11',
  'HG08D+11',
  'HE0812',
  'HM0812',
  'HG0812',
  'HE08D-12',
  'HM08D-12',
  'HG08D-12',
  'HE08D+12',
  'HM08D+12',
  'HG08D+12',
  'HE0813',
  'HM0813',
  'HG0813',
  'HE08D-13',
  'HM08D-13',
  'HG08D-13',
  'HE08D+13',
  'HM08D+13',
  'HG08D+13',
  'HE0814',
  'HM0814',
  'HG0814',
  'HE08D-14',
  'HM08D-14',
  'HG08D-14',
  'HE08D+14',
  'HM08D+14',
  'HG08D+14',
  'HE0815',
  'HM0815',
  'HG0815',
  'HE08D-15',
  'HM08D-15',
  'HG08D-15',
  'HE08D+15',
  'HM08D+15',
  'HG08D+15',
  'HE0816',
  'HM0816',
  'HG0816',
  'HE08D-16',
  'HM08D-16',
  'HG08D-16',
  'HE08D+16',
  'HM08D+16',
  'HG08D+16',
  'HE0817',
  'HM0817',
  'HG0817',
  'HE08D-17',
  'HM08D-17',
  'HG08D-17',
  'HE08D+17',
  'HM08D+17',
  'HG08D+17',
  'HE0818',
  'HM0818',
  'HG0818',
  'HE08D-18',
  'HM08D-18',
  'HG08D-18',
  'HE08D+18',
  'HM08D+18',
  'HG08D+18',
  'HE0819',
  'HM0819',
  'HG0819',
  'HE08D-19',
  'HM08D-19',
  'HG08D-19',
  'HE08D+19',
  'HM08D+19',
  'HG08D+19',
  'HE0820',
  'HM0820',
  'HG0820',
  'HE08D-20',
  'HM08D-20',
  'HG08D-20',
  'HE08D+20',
  'HM08D+20',
  'HG08D+20',
  'HE0821',
  'HM0821',
  'HG0821',
  'HE08D-21',
  'HM08D-21',
  'HG08D-21',
  'HE08D+21',
  'HM08D+21',
  'HG08D+21',
  'G5-IMS',
  'EAGU2-IMS',
  'G4',
  'L2-IME',
  'G3-IME',
  'L1',
  'G7',
  'ULE-IMS',
  'E1',
  'ULC',
  'HA-IMS',
  'G6-IME',
  'G4-IME',
  'G2-IME',
  'ULD',
  'L0',
  'L0-IME',
  'H0-IMS',
  'L2',
  'G3',
  'HA-IME',
  'ULD-IME',
  'ULA',
  'G1',
  'L1-IMS',
  'G0',
  'G6-IMS',
  'U1-IMS',
  'EAGU1-IME',
  'L1-IME',
  'HA',
  'E0',
  'G1-IME',
  'E0-IMS',
  'B1-IMS',
  'G7-IMS',
  'U1-IME',
  'ULB',
  'G7-IME',
  'L0-IMS',
  'EAGU1',
  'G4-IMS',
  'L2-IMS',
  'ULE-IME',
  'H0-IME',
  'G3-IMS',
  'G2-IMS',
  'H0',
  'B1',
  'ULF-IMS',
  'ULA-IME',
  'U0-IME',
  'G0-IME',
  'E0-IME',
  'EAGU2-IME',
  'ULA-IMS',
  'G1-IMS',
  'ULC-IMS',
  'ULD-IMS',
  'EAGU2',
  'HF-IME',
  'G5',
  'G6',
  'ULC-IME',
  'ULE',
  'E1-IME',
  'ULB-IME',
  'G2',
  'ULB-IMS',
  'E1-IMS',
  'G5-IME',
  'G0-IMS',
  'U0',
  'ULF-IME',
  'ULF',
  'EAGU1-IMS',
  'HF',
  'HF-IMS',
  'U0-IMS',
  'B1-IME',
  'U1',
  'SLP_Aggregate',
  'virtual',
  'LGZ',
];

export const validLoadProfileQualities = [
  '_BEST_VALUE_',
  'FINAL',
  'PREACT',
  'FORECAST',
  'PRE_FC',
  'PLAN',
  'BUDGET',
  'UNCLEAR',
];
